<!-- Start Containerbar -->
<div id="containerbar" class="containerbar authenticate-bg">
  <p-toast></p-toast>
  <!-- Start Container -->
  <div class="container">
    <div class="auth-box forgot-password-box">
      <!-- Start row -->
      <div class="row no-gutters align-items-center justify-content-center">
        <!-- Start col -->
        <div class="col-md-6 col-lg-5">
          <!-- Start Auth Box -->
          <div class="auth-box-right">
            <div class="card">
              <div class="card-body">
                <div class="form-head">
                  <a class="logo"
                    ><img
                      src="assets/images/logo.svg"
                      class="img-fluid"
                      alt="logo"
                  /></a>
                </div>
                <h4 class="text-primary my-4">Verify Account ?</h4>
                <p class="mb-4">
                  Enter the OTP below which has received in your colleague
                  notification.
                </p>
                <form
                  class="otp-form"
                  [formGroup]="otpForm"
                  (ngSubmit)="onVerify()"
                >
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="otp"
                      placeholder="Enter Received OTP"
                      required
                      formControlName="otp"
                      [ngClass]="{
                        'is-invalid': submitted && f.otp.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && f.otp.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.otp.errors.required">
                        Please Enter Received OTP
                      </div>
                      <div *ngIf="f.otp.errors.otp">Please Enter Valid OTP</div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div style="text-align: center">
                      <div class="form-group">
                        <div class="form-input">
                          <input
                            [type]="showPassword ? 'text' : 'password'"
                            class="form-control"
                            id="password-field"
                            placeholder="Password"
                            required
                            formControlName="password"
                            [ngClass]="{
                              'is-invalid': submitted && f.password.errors
                            }"
                          /><span class="icon">
                            <i
                              class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !showPassword,
                                'fa-eye': showPassword
                              }"
                              (click)="toggleFieldTextType()"
                            ></i
                          ></span>
                        </div>
                        <div
                          *ngIf="submitted && f.password.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.password.errors.required">
                            Please enter password
                          </div>
                          <div *ngIf="f.password.errors.pattern">
                            Minimum 8 characters, at least 1 uppercase letter, 1
                            lowercase letter, 1 number and 1 special character
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div style="text-align: center">
                      <div class="form-group">
                        <div class="form-input">
                          <input
                            [type]="hide ? 'text' : 'password'"
                            class="form-control"
                            id="confirmpassword"
                            placeholder="Confirm Password"
                            required
                            formControlName="confirmPassword"
                            [ngClass]="{
                              'is-invalid':
                                submitted && f.confirmPassword.errors
                            }"
                          /><span class="icon">
                            <i
                              class="fa"
                              id="confPass"
                              [ngClass]="{
                                'fa-eye-slash': !hide,
                                'fa-eye': hide
                              }"
                              (click)="togglePasswordType()"
                            ></i
                          ></span>
                        </div>

                        <div
                          *ngIf="submitted && f.confirmPassword.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.confirmPassword.errors.required">
                            Please enter password
                          </div>
                          <div *ngIf="f.confirmPassword.errors.mustMatch">
                            Passwords must match
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    class="btn btn-primary-rgba btn-lg btn-block font-18"
                  >
                    Verify
                  </button>
                </form>
                <!-- <p class="mb-0 mt-3">Remember Password? <a routerLink="/login">Log in</a></p> -->
              </div>
            </div>
          </div>
          <!-- End Auth Box -->
        </div>
        <!-- End col -->
      </div>
      <!-- End row -->
    </div>
  </div>
  <!-- End Container -->
</div>
<!-- End Containerbar -->
